'use strict';

/* eslint-env browser */
module.exports = self;
